export enum UnitType {
    TIME = 'Time',
    STRING = 'String',
    PERCENTAGE = 'Percentage'
}